// extracted by mini-css-extract-plugin
export var infoRow = "_om-2";
export var labelContainer = "_om-0";
export var rightInfo = "_om-1";